export const CANDIDATE_DETAILS_DE = {
  chat: {
    header: 'Geben Sie hier ein Feedback',
    toggleButton: 'Mit {{ managerName }} chatten',
    toggleButton_open: '$t(candidateDetails.chat.header)',
    toggleCloseHint: 'Schließen',
    fullScreenButton: 'Vollbild',
    sendButtonAriaLabel: 'Senden',
    message: {
      heading:
        '{{ authorFullName }} - $t(common.formatting.date.dateFormat) um $t(common.formatting.date.dateFormat_time)',
      defaultMessageFeedback:
        'Hallo {{ name }}, wenn Sie uns etwas mitteilen möchten, verwenden Sie diesen Chat.',
      defaultMessageFeedback_positive:
        'Hallo {{ name }}, warum ist <strong>er/sie interessant</strong>? Möchten Sie einen bestimmten Punkt im Bewerbungsgespräch?',
      defaultMessageFeedback_negative:
        'Hallo {{ name }}, schreiben Sie uns Ihre Begründung, damit wir unsere Suche anpassen können.',
    },
  },
  dossier: {
    title: 'Summary & CV',
    subtitle: 'Vorstellungsgespräch',
    button: 'Dossier herunterladen',
    showCurriculumButton: 'Lebenslauf anzeigen',
    modalTitle:
      '{{ candidateFullName }} | $t(candidate.sections.curriculum.title)',
    modalCloseButtonAriaLabel: 'Schließen',
  },
  feedback: {
    bubble:
      'Möchtest du {{ candidateFullName }} in einem <strong>Vorstellungsgespräch</strong> besser kennenlernen?',
    bubble_interested:
      '<strong>{{ candidateFullName }}</strong> ist interessant',
    bubble_notInterested:
      '<strong>{{ candidateFullName }}</strong> ist uninteressant',
    bubble_discarded:
      '<strong>{{ candidateFullName }}</strong> setzt nicht fort.',
    actionYes: 'Ja',
    actionNo: 'Nein',
    actionChangeFeedback: 'Haben Sie Ihre Meinung geändert?',
    interesting: 'Es ist interessant',
  },
  info: {
    age: '{{ age }} Jahre',
    drivingTime: {
      hours: '<strong>{{ hours }}</strong>h',
      minutes: '<strong>{{ minutes }}</strong>min',
    },
  },
  intro: {
    editLink: 'Bewerbung bearbeiten',
  },
  negativeFeedback: {
    title: 'Warum ist er/sie nicht interessant?',
    subtitle:
      'Zu wissen, warum Sie diesen Kandidaten nicht für geeignet für die Position halten (z.B. Fähigkeiten, Erfahrung, etc.) hilft uns, nur Kandidaten vorzustellen, die perfekt Ihren Erwartungen entsprechen.',
    notesLabel: 'Schreiben Sie die Begründung:',
    notesPlaceholder:
      'Die Begründung wird an den Headhunter gesendet, der die Suche betreut.',
    submit: 'Senden',
    cancel: 'Abbrechen',
    successTitle: 'Nachricht gesendet:',
    successSubtitle:
      'Wir haben Ihre Bewertung an den Headhunter weitergeleitet, der die Suche betreut.',
    successClose: 'Ok, danke.',
  },
  scout: {
    accordionOpen: 'Mehr',
    accordionClose: 'Schließen',
    title: 'Scoutbericht',
    accordionTitle_skillsAssessment: 'Kompetenzbewertung',
    accordionTitle_overallAssessment: 'Rollenzusammenfassung',
    button: 'Bericht herunterladen',
  },
};
